
export function normalizeRewardfulVia(input: string | null | undefined): string | null {
  if (!input || typeof input !== "string") {
    return null;
  }

  const trimmed = input.trim();
  if (!trimmed) {
    return null;
  }

  const looksLikeUrl =
    trimmed.includes("://") ||
    trimmed.startsWith("www.") ||
    (trimmed.includes("?via=") && trimmed.includes("."));

  if (looksLikeUrl) {
    try {
      const urlString = trimmed.startsWith("http") ? trimmed : `https://${trimmed}`;
      const url = new URL(urlString);
      const viaParam = url.searchParams.get("via");

      if (viaParam && viaParam.trim()) {
        return sanitizeViaCode(viaParam.trim());
      }

      return null;
    } catch {
      return sanitizeViaCode(trimmed);
    }
  }

  return sanitizeViaCode(trimmed);
}

function sanitizeViaCode(code: string): string | null {
  const cleaned = code.trim();

  if (!cleaned || cleaned.length > 50) {
    return null;
  }

  if (!/^[a-zA-Z0-9_-]+$/.test(cleaned)) {
    return null;
  }

  return cleaned;
}
